export default "__VITE_ASSET__BgxCggAg__"